//--------DOCUMENTATION--------
//This widget has 2 modes for the view: 1) a condensed version, and 2) a full version.  By default, only the condensed 
//version is shown, and the full version is called via AJAX from within the short version.

//    Dependencies:
//1. CDN Chartist.CSS <link rel="stylesheet" href="bower_components/chartist/dist/chartist.min.css">
//2. CDN Chartist.js  <script src="bower_components/chartist/dist/chartist.min.js">
//3. ArticleLevelMetrics.js --> which should ship over in the SharedWidgets NuGet Package
//4. _article-level-metrics.scss --> default presentation for the widget. should ship over with NuGet Package.
var ArtMetric = {};
var $body = $('body');
var $printableModal = $('.js-printable-metrics-modal');


ArtMetric.fullVersion = function ($dest, routeUrl) {

    // Code from https://github.com/gionkunz/chartist-js/issues/1015
    var ctHtmlLabels = function (options) {
        return function (chart) {
            chart.on('draw', function (context) {
                if (context.type === 'label') {
                    var redo = context.element._node.childNodes[0];
                    redo.innerHTML = redo.innerText;
                }
            });
        };
    };   


    var $chart = $dest.find('.js-ct-chart');
    var chartClass = '.ct-chart';
    if ($dest.closest('.widget-SplitView').length) {
        $chart.addClass('sv-ct-chart');
        chartClass = '.sv-ct-chart';
    }

    // Only do AJAX call if it hasn't been done before.
    var $viewMetrics = $dest.find('.js-metric-full-wrap');
    if ($viewMetrics.length < 1) {
        var baseSiteUrl = $('#hfSiteURL');

        if (typeof baseSiteUrl != 'undefined' && typeof baseSiteUrl.val() != 'undefined' && baseSiteUrl != '') {
            routeUrl = '//' + baseSiteUrl.val() + routeUrl;
        }

        $.ajax({
            url: routeUrl,
            datatype: 'HTML',
            success: function (html) {
                $dest.prepend(html);                
                updateChart(ctHtmlLabels, chartClass);
            },
            error: function (xmlHttpRequest, textStatus, errorThrown) {
                if (window.console) {
                    var err = eval('(' + xmlHttpRequest.responseText + ')');
                    console.error('error: ' + err);
                    console.error('status: ' + textStatus);
                }
            }
        });
    }
    else if ($chart.html().length === 0) {
        $viewMetrics.removeClass('hide');
        updateChart(ctHtmlLabels, chartClass);
    }
};

function updateChart(ctHtmlLabels, chartClass) {
    setTimeout(function () {
        if (typeof window.ChartistData !== 'undefined') {
            // Chartist Options
            var opts = {
                lineSmooth: false,
                showArea: true,
                low: 0,
                plugins: [ctHtmlLabels]
            };

            var responsiveOpts = [
                ['screen and (max-width: 1024px)', {
                    axisX: {
                        labelInterpolationFnc: function (value) {
                            return value.slice(0, 3);
                        }
                    }
                }],
                ['screen and (min-width: 1px)', {
                    axisX: {
                        labelInterpolationFnc: function (value) {
                            return value;
                        }
                    },
                    plugins: [ctHtmlLabels]
                }]
            ];
            
            ArtMetric.createChart(chartClass, window.ChartistData.data, opts, responsiveOpts);
           
        }
    }, 200);
    ArtMetric.reloadDimensionsBadge();
}

ArtMetric.reloadDimensionsBadge = function () {
    var hasDimensionsWidget = $('.contentmet-dimensions').length || $('.artmet-dimensions').length;
    if (hasDimensionsWidget &&
        window.__dimensions_embed &&
        window.__dimensions_embed.addBadges) {
        if ($('.__dimensions_badge_embed__').length) {
            $('.__dimensions_badge_embed__').removeAttr('data-dimensions-badge-installed');
            $('.__dimensions_badge_embed__').empty();
        }
        window.__dimensions_embed.addBadges();
    }
};

ArtMetric.limitLabels = function () {
    // limit which labels are being displayed
    var xAxisLabels = $('.ct-horizontal.ct-label');
    var labelCt = xAxisLabels.length;

    // max number of labels to show is 8. so if there are 16..we'll show every other. 24 -- every third, etc.
    var showNthLabel = Math.ceil(labelCt / 8);
    var counter = 1;

    xAxisLabels.not(':eq(0)').each(function () {
        if (!(counter % showNthLabel === 0)) {
            $(this).hide();
        }
        counter++;
    });
};

ArtMetric.createChart = function (cssSelector, data, options, responsiveOptions) {
    var chart = new Chartist.Line(cssSelector, data, options, responsiveOptions);

    // Let's put a sequence number aside so we can use it in the event callbacks
    var seq = 0,
      delays = 25,
      durations = 250;

    // Once the chart is fully created we reset the sequence
    chart.on('created', function () {
        seq = 0;
        ArtMetric.limitLabels();
    });

    chart.on('draw', function (data) {
        if (data.type === 'line' || data.type === 'point' || data.type === 'area') {
            seq++;
        }

        if (data.type === 'line') {
            data.element.animate({
                opacity: {
                    begin: seq * delays + 150,
                    dur: durations,
                    from: 0,
                    to: 1
                }
            });
        } else if (data.type === 'point') {
            data.element.animate({
                x1: {
                    begin: seq * delays,
                    dur: durations,
                    from: data.x - 10,
                    to: data.x,
                    easing: 'easeOutQuart'
                },
                x2: {
                    begin: seq * delays,
                    dur: durations,
                    from: data.x - 10,
                    to: data.x,
                    easing: 'easeOutQuart'
                },
                opacity: {
                    begin: seq * delays,
                    dur: durations,
                    from: 0,
                    to: 1,
                    easing: 'easeOutQuart'
                }
            });
        } else if (data.type === 'area') {
            data.element.animate({
                opacity: {
                    begin: seq * delays + 250,
                    dur: 300,
                    from: 0,
                    to: 1
                }
            });
        }
    });
};

function getWidgetInstanceName(widgetClass) {
    var widgetInstanceName = '';
    var className = $(widgetClass).attr('class');
    var widgetInstanceIdx = className.indexOf('widget-instance-');
    if (widgetInstanceIdx >= 0) {
        widgetInstanceName = className.substr(widgetInstanceIdx).split('-')[2];
    }
    return widgetInstanceName;
}

ArtMetric.triggerModal = function ($modal, articleId, viewName = '') {
   
    var showDimensionsBadge = $('.artmet-dimensions').length ? 'true' : 'false';

    var viewName = viewName.length > 0 ? viewName : 'ArticleLevelMetrics'
    var routeUrl = '/ThirdParty/ArticleLevelMetricsDetailsCustomView';
    var widgetInstance = getWidgetInstanceName('.widget-ArticleLevelMetrics');
    if (widgetInstance.length > 0) {
        routeUrl += '/' + widgetInstance;
    }
    routeUrl += '?articleId=' + articleId + '&showDimensionsBadge=' + showDimensionsBadge + '&viewName=' + viewName;

    ArtMetric.fullVersion($modal, routeUrl);   

    var $modalWrap = $modal.parent();
    $modalWrap.css({ 'display': 'block', 'opacity': 1 });
    $body.addClass('metrics-modal-open');

    if ($printableModal.length > 0) {   // Only add the open class if the printable modal is already on the page.
                                        // Otherwise, the js that creates the printable modal will add the class.
        $printableModal.addClass('metrics-modal-open');
    }
};

ArtMetric.closeModal = function () {
    var $modalWrap = $('.artmet-modal:visible');
    $modalWrap.attr('style', '');
    $body.removeClass('metrics-modal-open');
    $printableModal.removeClass('metrics-modal-open');
};

ArtMetric.eventsToClose = function () {
    $('.js-artmet-close-modal').click(function () {
        ArtMetric.closeModal();
    });

    $('.js-artmet-modal').click(function () {
        if (!$(event.target).closest('.artmet-modal-contents').length) {
            ArtMetric.closeModal();
        }
    });
};

// In order to hide the main content but still display the modal, 
// we need to have the modal outside of the main div container.
// So this function makes a clone of the modal and adds it as a child 
// of the document body.
ArtMetric.cloneMetricsModalForPrint = function ($metricsModal) {
    if ($printableModal.length == 0 && $metricsModal.length) {
        var $printModal = $('<div/>', { 'class': 'printable-metrics-modal js-printable-metrics-modal' });

        $metricsModal.clone().appendTo($printModal);

        if ($('body.metrics-modal-open').length > 0) {
            $printModal.addClass('metrics-modal-open');
        }

        $body.append($printModal);
        $printableModal = $('.js-printable-metrics-modal');
    }
};

$(document).ready(function () {

    $('.widget-ArticleLevelMetrics:visible').on('click', '.js-artmet-modal-trigger, .artmet-condensed-stats .artmet-views', function(e) {
        var articleId = $('.widget-ArticleLevelMetrics:visible .artmet-modal-trigger').attr('data-article-id')
            ?? $('.widget-ArticleLevelMetrics:visible .artmet-modal-trigger').attr('data-resource-id');
        var viewName = $('.widget-ArticleLevelMetrics:visible .artmet-modal-trigger').attr('data-view-name');
        // could have splitview version too, but just use the first one
        // so we don't have 2 copies
        ArtMetric.triggerModal($('.artmet-modal-contents').first(), articleId, viewName);
    });
    $(window).on('beforeprint', function () {
        // Only grab the modal contents if the modal has already been populated (js-metric-full-wrap exists)
        // Only grab the first metrics modal, in case split view and standard view have created separate modal instances.
        var $metricsModal = $('.js-metric-modal-contents:has(.js-metric-full-wrap):first');
        if (!$printableModal.length && $metricsModal.length) {
            // In order for our @print css rules to work, we need to create a clone of the modal
            ArtMetric.cloneMetricsModalForPrint($metricsModal);
        }
    });
    ArtMetric.eventsToClose();

    $('.__dimensions_badge_embed__').on('dimensions_embed:show', function () {
        $('.__dimensions_badge_embed__').closest('.artmet-item').removeClass('hide');
        $('.__dimensions_badge_embed__').closest('.contentmet-citations').removeClass('hide');
        if ($('.artmet-wos').length === 0 && $('.artmet-altmetric').length) {
            $('.artmet-citations').addClass('artmet-citation-border-bottom');
        }
    });
    $('.altmetric-embed').on('altmetric:show', function () {            
        $('.altmetric-embed').closest('.artmet-item').removeClass('hide'); 
    }); 
});
